import BaseService from '@src/services/BaseService'

class InsightsAlertsService extends BaseService {
    constructor() {
        super('dashboards/insights/alerts')
    }

    /**
     * Fetch insights alerts summary (counts + items for each alert type).
     * @param {Object} [params={}] - Optional filters: business_unit_id, team_id, role_id, user_id
     * @returns {Promise}
     */
    fetchAlerts(params = {}) {
        return this.fetchAll(params)
    }

    /**
     * Fetch full list of records for a single alert type (for modal/export).
     * @param {string} alertType - One of: promoters_without_roteiro_next_3_days, stores_not_visited_last_week_without_roteiro, stores_not_visited_this_week_with_roteiro, users_inactive_mobile_7_days
     * @param {Object} [params={}] - Same filters as fetchAlerts
     * @returns {Promise<{ count: number, items: Array }>}
     */
    fetchAlertDetail(alertType, params = {}) {
        return this.fetchAll(params, `detail/${alertType}`)
    }
}

export default new InsightsAlertsService()
